import * as net from "../vipa/net";

export class Case {
    constructor() {
        $("#modal-variant")
            .on("click", "#variantModal-checkAvailability", this.click);
        $("#modal-variant")
            // @ts-ignore
            .on("keydown", "#variantModal-quantity", this.enter);
    }

    enter = (event: JQuery.KeyDownEvent) => {
        if (event.key === "Enter") {
            event.preventDefault();
            $("#variantModal-checkAvailability").trigger("click");
        }
    }

    click = (event: JQuery.ClickEvent) => {
        $("#variantModal-checkAvailability .fa-spin").show();
        let product_id = this.getProductId(event);
        let quantity = (<HTMLInputElement>$("#variantModal-quantity")[0])
            .value;
        let data = {
            jsonrpc: "2.0",
            id: null,
            product_id: product_id,
            quantity: quantity
        }
        let url;
        if (globalThis.lang) {
            url = `/${globalThis.lang}/j/availability/`;
        } else {
            url = "/j/availability/";
        }
        net.postJSON(url, data, this.clickSuccess)
            .fail(this.clickFail);
    }

    clickSuccess(response: JQuery.PlainObject): void {
        $("#variantModal-pricing").html(response["variantModal-pricing"]);

        $("#variantModal-checkAvailability .fa-spin").hide();
    }

    clickFail(response: JQuery.jqXHR): void {
        let modal = $("#modal-small");
        let content = $("#modal-small div");

        content.html(response.responseJSON.error);
        modal.foundation("open");
    }

    private getProductId(event: JQuery.ClickEvent | JQuery.KeyDownEvent): number {
        let product_id = parseInt(
            $(event.currentTarget)
                .closest(".product")
                .data("id")
        );
        return product_id
    }
}
